<template>
  <v-container>
    <v-card class="mx-auto" max-width="344">
      <v-card-text>
        <div>Current Reported Accreditation</div>
        <p class="text-h4 text--primary">
          {{ this.reportedAccred }}
        </p>
        <p v-if="this.reportedAccred < 1" class="text-h6 text--primary">
          You do not have a current reported accreditation. You can register yours by visiting the <br><br><a href="https://bqref.ownurgoal.net.au" target="_blank">BQ Referee Registration Portal</a> <br><br>It is recommended that you do this process on a computer instead of a mobile device.
        </p>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn text color="deep-purple accent-4" to="Pathway">
          Explore Referee Pathways
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>



<script>
import accreditationData from "../data/Accreditation";

export default {
  data: () => ({
    reportedAccred: "",
    absolute: true,
    overlay: false,
    accreditationData,
    interval: {},
    show: false,
    nextAccred: false,
    progressCount: accreditationData[4].progressCount,
    tab: null,
    items: ["Level of Game", "Competencies"],
  }),

  created(){
    this.loadReportedAccred();
  },

  methods: {
    loadReportedAccred() {
      this.referee = JSON.parse(
        localStorage.getItem("Referee")
      ).contact_details;
      this.referee
      this.referee.forEach((element) => {
        if (element.Code === 1934) {
          this.reportedAccred = element.Description;
        }
      });
    },
  },
};
</script>

